// extracted by mini-css-extract-plugin
export default {"wrap":"Toc_wrap__dA2Lq","toc":"Toc_toc__JCV3o","active":"Toc_active__24H7x"};